import { render, staticRenderFns } from "./ReceiveAwards.vue?vue&type=template&id=77fdb3f3&scoped=true"
import script from "./ReceiveAwards.vue?vue&type=script&lang=js"
export * from "./ReceiveAwards.vue?vue&type=script&lang=js"
import style0 from "./ReceiveAwards.vue?vue&type=style&index=0&id=77fdb3f3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77fdb3f3",
  null
  
)

export default component.exports